import { render, staticRenderFns } from "./realizedTable.vue?vue&type=template&id=15807ead&scoped=true&"
import script from "./realizedTable.vue?vue&type=script&lang=ts&"
export * from "./realizedTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15807ead",
  null
  
)

export default component.exports